import React from 'react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '../ui/select';
import { Badge } from '../ui/badge';
import { REGIME_STYLES } from './useLegalForm';

const ORDER = ['company', 'sole_trader', 'partnership', 'nonprofit', 'branch'];

export const LegalFormPicker = ({ options, value, onChange, testId = 'legal-form-select', className = 'h-14 text-lg' }) => {
  const forms = options?.forms || [];
  const regimes = options?.regimes || {};
  const selected = forms.find((f) => f.code === value);
  const groups = ORDER.filter((r) => forms.some((f) => f.regime === r));

  return (
    <div className="space-y-2">
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger className={className} data-testid={testId}>
          <SelectValue placeholder="Select the legal form of your business" />
        </SelectTrigger>
        <SelectContent className="max-h-80">
          {groups.map((regime) => (
            <SelectGroup key={regime}>
              <SelectLabel className="text-xs uppercase tracking-wide text-muted-foreground">{regimes[regime]?.label || regime}</SelectLabel>
              {forms.filter((f) => f.regime === regime).map((f) => (
                <SelectItem key={f.code} value={f.code} data-testid={`legal-form-option-${f.code}`}>{f.label}</SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
      {selected && (
        <div className="flex items-start gap-2 rounded-lg border bg-muted/40 p-3" data-testid="legal-form-description">
          <Badge variant="outline" className={`shrink-0 ${REGIME_STYLES[selected.regime] || ''}`} data-testid="legal-form-regime-badge">
            {regimes[selected.regime]?.label?.split(' (')[0] || selected.regime}
          </Badge>
          <p className="text-xs text-muted-foreground leading-relaxed">{selected.description}</p>
        </div>
      )}
    </div>
  );
};
